export type Cursor<T> = {
  data: T;
  cursor?: string;
};

export type UserProfile = {
  role: string;
};

export enum PortalRole {
  User,
  Admin,
  NonExisting,
}

export type SecurityEvent = {
  id: string;
  timeStamp: string;
  event: string;
  serial: unknown;
  context: unknown;
};

export type RoleAssignment = {
  userId: string;
  name: string;
  principalName: string;
  role: string;
  expiresOn: string | undefined;
};

export type StartPresetSyncRequest = {
  machineIds: string[] | null;
  presetIds: string[] | null;
  includeOffline: boolean;
};
